import { ReduxService } from 'dashboard-services/services';

import { shareInsightActions } from 'actions/modules/insight';

export const shareInitialState = {
  insightName: undefined,
  insightGroupName: undefined,
  shouldPublish: undefined,
  shouldCreatePublicLink: undefined,
  expirationDate: undefined,
  isFromList: false,
  isOpen: false
}

export const shareState = (state = shareInitialState, action) => {
  switch (action.type) {
    case shareInsightActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}